import i18n from 'simple-react-i18n'
import Checkbox from '../../../components/forms/Checkbox'
import { StyledFieldSet, StyledLegend } from '../../../components/StyledElements'
import { Grid, Stack, Tooltip } from '@mui/material'
import RadioButtons from '../../../components/forms/RadioButtons'
import Select from '../../../components/forms/Select'
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import NumberField from '../../../components/forms/NumberField'
import Button from '../../../components/forms/Button'
import { isNil } from 'lodash'
import SettingsIcon from '@mui/icons-material/Settings'
import InfoIcon from '@mui/icons-material/Info'

const DAY = 'DAY'
const HOUR = 'HOUR'

const CUMUL_MAX = 'CUMUL_PERSO_MAX'
const CUMUL_MIN = 'CUMUL_PERSO_MIN'
const CUMUL_SUM = 'CUMUL_PERSO_SUM'
const CUMUL_AVERAGE = 'CUMUL_PERSO_AVERAGE'

// deprecated use HydroOption instead
const GroupedHydroPanel = ({
    hydroGrouped,
    setHydroGrouped,
    left = 460,
}) => {
    const [isOpen, setIsOpen] = useState(false)
    const [isPersonalizedGrouping, setIsPersonalizedGrouping] = useState(false)
    const [optionDayHourSelected, setOptionDayHourSelected] = useState(HOUR)
    const [hoursCumul, setHoursCumul] = useState(1)
    const [optionCumulSelected, setOptionCumulSelected] = useState(CUMUL_MAX)

    const onClosePopinCumul = () => {
        const day = `${optionCumulSelected}_${hoursCumul * 24}`
        const hour = `${optionCumulSelected}_${hoursCumul}`
        setHydroGrouped(optionDayHourSelected === DAY ? day : hour)
        setIsPersonalizedGrouping(false)
    }


    const changeGroupedDate = (group) => {
        setHydroGrouped(group)
        setIsOpen(false)
    }

    const optionDayHour = [
        { value: HOUR, label: i18n.hour },
        { value: DAY, label: i18n.day },
    ]
    const optionCumul = [
        { value: CUMUL_MAX, label: i18n.max },
        { value: CUMUL_MIN, label: i18n.min },
        { value: CUMUL_SUM, label: i18n.sum },
        { value: CUMUL_AVERAGE, label: i18n.average },
    ]
    const isCumul= hydroGrouped.slice(0, 5) === 'CUMUL'
    return (
        <Grid sx={{
            left,
            position: 'relative',
            width: '30px',
        }}
        >
            <Tooltip title={i18n.hydrometricGrouping}>
                <SettingsIcon
                    sx={{ top: '4px', margin: '0 15px', fontSize: 35, cursor: 'pointer' }}
                    onClick={() => setIsOpen(!isOpen)}
                />
            </Tooltip>
            {isOpen && (
                <Grid sx={{
                    left: '35px',
                    zIndex: 10,
                    position: 'absolute',
                }}
                >
                    <Stack sx={{
                        backgroundColor: 'white',
                        border: '1px solid',
                        borderRadius: 1,
                        borderColor: '#8f8f8fff',
                        width: '450px',
                        padding: 1,
                    }}
                    >
                        <Grid container justifyContent='center' alignItems='center'>
                            <h5>{ i18n.regrouping }</h5>
                        </Grid>
                        <Grid container alignItems='center'>
                            <Checkbox checked={ hydroGrouped === 'AUTO' && !isPersonalizedGrouping } label={ i18n.auto } onChange={() => changeGroupedDate('AUTO') } />
                            <Tooltip title={i18n.descriptionCumulAuto}>
                                <InfoIcon sx={{ fontSize: 20, color: 'grey' }}/>
                            </Tooltip>
                        </Grid>
                        <Checkbox checked={ hydroGrouped === 'all' && !isPersonalizedGrouping } label={`${i18n.allMeasures}`} onChange={() => changeGroupedDate('all') } />
                        <Checkbox checked={ isPersonalizedGrouping || isCumul } label={ i18n.personalizedGrouping } onChange={() => setIsPersonalizedGrouping(prev => !prev) } />
                        <StyledFieldSet>
                            <StyledLegend>{ i18n.personalizedGrouping }</StyledLegend>
                            <Grid container justifyContent='space-evenly' spacing={1} sx={{ padding: '15px' }} >
                                <Grid container justifyContent='center' size={12}>
                                    <RadioButtons
                                        label={ i18n.modeDaysHours }
                                        elements={optionDayHour}
                                        selected={optionDayHourSelected}
                                        onChange={setOptionDayHourSelected}
                                        disabled={ !isPersonalizedGrouping }
                                    />
                                </Grid>
                                <Grid size={6}>
                                    <Select
                                        label={ i18n.modeGrouping }
                                        options={optionCumul}
                                        value={optionCumulSelected}
                                        onChange={setOptionCumulSelected}
                                        disabled={ !isPersonalizedGrouping }
                                    />
                                </Grid>
                                <Grid size={6}>
                                    <NumberField
                                        title={ i18n.numberHoursDays }
                                        value={ hoursCumul }
                                        onChange={ setHoursCumul }
                                        min={ 1 }
                                        disabled={ !isPersonalizedGrouping }
                                    />
                                </Grid>
                                <Button title={ i18n.calculate } onClick={ onClosePopinCumul } variant='outlined' disabled={ !isPersonalizedGrouping || isNil(hoursCumul) } />
                            </Grid>
                        </StyledFieldSet>
                    </Stack>
                </Grid>
            )}
        </Grid>
    )
}
GroupedHydroPanel.propTypes = {
    hydroGrouped: PropTypes.string,
    setHydroGrouped: PropTypes.func,
    left: PropTypes.number,
}

export default GroupedHydroPanel